// extracted by mini-css-extract-plugin
module.exports = {"layout":"C_bp","ui":"C_P","ui__toggle":"C_bq","ui____minimized":"C_Q","content":"C_br","toosmall":"C_bs","content__shadow":"C_bt"};